import i18n from '../../i18n';

const translatedErrorMessages = {
  name: () => i18n.t('contact.input_name_error'),
  company: () => i18n.t('contact.input_name_error'),
  email: () => i18n.t('contact.input_email_error'),
  phone: () => i18n.t('contact.input_phone_error'),
  message: () => i18n.t('contact.input_message_error'),
};

export function clearError(type) {
  this[type].error = '';
  this[type].state = 'default';

  if (this.status === 'ERROR') {
    this.status = 'IDLE';
  }
}
export function activate(type) {
  this[type].active = true;
}
export function findActiveInputs(...inputs) {
  return inputs.filter(input => input.active);
}

export function isInValid(type, input) {
  switch (type) {
    case 'name':
    case 'company':
      if (input.text.length < 2) {
        return true;
      }
      return false;
    case 'email':
      if (
        !/[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,64}/i.test(input.text)
      ) {
        return true;
      }
      return false;
    case 'phone':
      if (input.text.length < 7) {
        return true;
      }
      return false;
    case 'message':
      if (input.text.length < 10) {
        return true;
      }
      return false;
    default:
      return true;
  }
}

export function testErrorMessage(type) {
  const errorMessage = translatedErrorMessages[type];
  if (errorMessage) {
    this[type].error = errorMessage();
    this[type].state = 'error';
  }
}

export function createFormData({
  name,
  email,
  company,
  phone,
  message,
  recaptchaToken,
}) {
  const formData = new URLSearchParams();
  if (company) {
    formData.append('company', company);
  }
  formData.append('g-recaptcha-response', recaptchaToken);
  formData.append('name', name);
  formData.append('email', email);
  formData.append('phone_number', phone);
  formData.append('message', message);
  return formData;
}
